<ion-content class="safe-area-top white">

    <app-modal-header></app-modal-header>

    <div class="content-spacing px-lg">

        <div>
            <div class="ts-h4-sans">{{ 'Crea il tuo account' | translate }}</div>
            <div class="ts-caption pt-xsm">{{ 'Registrati e pubblica i tuoi contenuti' | translate }}</div>
        </div>

        <div class="pt-xl">
            <app-simple-input [label]="'Email'"
                              type="email"
                              [placeHolder]="'Es: info@fivelab.it'"
                              [control]="registerForm.get('email') | formControlConverter"></app-simple-input>
        </div>

        <div class="pt-xl">
            <app-simple-input [label]="'Nome'"
                              [placeHolder]="'Es: Mario'"
                              [control]="registerForm.get('name') | formControlConverter"></app-simple-input>
        </div>

        <div class="pt-xl">
            <app-simple-input [label]="'Cognome'"
                              [placeHolder]="'Es: Rossi'"
                              [control]="registerForm.get('lastName') | formControlConverter"></app-simple-input>
        </div>

        <div class="pt-xl">
            <app-simple-input [label]="'Password'"
                              type="password"
                              [control]="registerForm.get('password') | formControlConverter"></app-simple-input>
        </div>

        <div class="pt-xl d-flex ion-align-items-center gap-2">
            <ion-checkbox [formControl]="registerForm.get('policyAccepted') | formControlConverter"></ion-checkbox>
            <div (click)="onTogglePolicy()" class="ts-caption">
                {{ 'Dichiaro di aver letto e accettato' | translate }}
                <span [routerLink]="['/privacy']" class="link-apperance">Policy</span>
            </div>
        </div>

        <div class="w-100 pt-xl safe-area-bottom">
            <ion-button
                    [disabled]="registerForm.invalid || registerProgress"
                    (click)="onRegister()" class="w-100 d-flex">
                <ion-spinner *ngIf="registerProgress"
                             class="mr-sm" name="crescent"></ion-spinner>
                <span>{{ 'Registrati' | translate }}</span>
            </ion-button>

        </div>

    </div>

</ion-content>
